import { Dialog } from '@mui/material'
import { createContext, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import kycIconSvg from 'src/assets/kyc approval.svg'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import {
  KycIcon,
  KycPendingContent,
  KycPendingPaper,
  KycProceedButton,
  KycSubText,
  KycText,
} from 'src/mentor/layout/Styles'
import ClinicHeaderAndContent from '../components/ClinicHeaderAndContent'
import ClinicSidebar from '../components/ClinicSidebar'
import { ClinicLayoutContext } from '../context/ClinicLayoutProvider'
import ClinicFooter from '../components/footer/ClinicFooter'
import { ROLE_TYPES } from 'src/consumer/constants'

/////////////////////////////////////

export const ClinicSetupContext = createContext(null)

///

export const LayoutChildComponent = () => {
  const location = useLocation()
  const contextValue = useContext(ClinicDataContext)
  
  // Handle case where context might be null (shouldn't happen, but defensive coding)
  if (!contextValue) {
    return null
  }
  
  const { chosenRoleFlow, ownerData, assistantData } = contextValue

  // const [kycPending, showKycPending] = useState(false)
  // const [modalsViewCount, setModalsViewCount] = useState({
  //   kyc: 0,
  // })
  const { showSidebar } = useContext(ClinicLayoutContext)
  // function setKycPending(state, force = false) {
  //   if (state === true) {
  //     setModalsViewCount((prev) => ({ ...prev, kyc: prev?.kyc + 1 }))
  //   }
  //   if (modalsViewCount > 0) {
  //     force ? showKycPending(state) : showKycPending(false)
  //     return
  //   }
  //   showKycPending(state)
  // }
  // function handleClose() {
  //   setKycPending(false)
  // }
  // useEffect(() => {
  //   if (!profileContextLoading) {
  //     // needs to be fixed considering profiledata is array
  //     if (profileData?.[0]?.onboarded) {
  //       const availableRoles = getAllRolesInBoolean()
  //       if (availableRoles.isClinicProspect) {
  //         setKycPending(true)
  //       }
  //     } else {
  //       setKycPending(false)
  //     }
  //   }
  // }, [profileContextLoading])

  const shouldHideSidebar = location?.pathname
    ?.split('/')
    .some(
      (path) =>
        path === 'new-brand-onboarding' ||
        path === 'new-clinic' ||
        path === 'chamber-screen-home' ||
        path === 'counter-screen',
    ) || location?.pathname?.startsWith('/clinic-home') || location?.pathname?.startsWith('/ca-home') || location?.pathname?.startsWith('/kiosk')

  return (
    <>
      {!shouldHideSidebar && showSidebar && <ClinicSidebar />}
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', flex: 1 }}>
        <ClinicHeaderAndContent
          removeLeftMargins={shouldHideSidebar || !showSidebar}
        />
        {/* Add Clinic Footer - only show if NOT Clinic Assistant */}
        {chosenRoleFlow !== ROLE_TYPES.roleClinicAssistant && <ClinicFooter />}
      </div>
      {/* <MentorKycPendingModal open={kycPending} onClose={handleClose} /> */}
    </>
  )
}

/////////////////////////

function MentorKycPendingModal({ onClose, ...rest }) {
  return (
    <Dialog sx={{ backdropFilter: 'blur(4px)' }} PaperComponent={KycPendingPaper} {...rest}>
      <KycPendingContent>
        <KycIcon src={kycIconSvg} />
        <div className="d-flex flex-column justify-content-center align-items-center gap-1">
          <KycText>KYC Approval Pending</KycText>
          <KycSubText>
            Your KYC approval is pending. We will send you an email when it is approved.
          </KycSubText>
        </div>
        <KycProceedButton onClick={onClose}>Close </KycProceedButton>
      </KycPendingContent>
    </Dialog>
  )
}
